<template>
    <spinner />
</template>

<script>
import { mapGetters } from 'vuex'
import Spinner from '@/components/Spinner'
import { PLATFORM_AUTHORIZE, FETCH_PROFILE } from '@/store/actions.type'

export default {
  name: 'TiendaNubeIntegrationPage',
  components: {
    Spinner
  },
  data() {
    return {
      integrationDone: false
    }
  },
  props: {
    type: {
      type: String,
      default: 'ongoing'
    }
  },
  computed: {
    ...mapGetters([
      'user'
    ])
  },
  watch: {
    user(val) {
      if (!this.integrationDone) {
        if (this.$route.query.code) this.setTNIntegration()
        else this.$router.push({ name: 'search' })
      }
    }
  },
  beforeMount() {
    this.$store.dispatch(FETCH_PROFILE)
  },
  methods: {
    setTNIntegration() {
      if (this.user && this.user.company_id) {
        this.$store.dispatch(PLATFORM_AUTHORIZE, {slug: 'tienda-nube', code: this.$route.query.code})
          .then(response => {
            this.integrationDone = true
            this.$store.dispatch(FETCH_PROFILE).then(response => {
              let payload = { profile: this.user }
              this.$store.commit('setProfile', payload)
              this.$router.push({name: 'integration-settings', params: { slug: 'tienda-nube' }})
            })
          }, error => {
            let message
            if (error.status === 422) {
              message = this.$gettext('Authorization code doesn\'t exist or is invalid for the client.<br><br>Please try again now you are identified here.')
            } else {
              message = this.$gettextInterpolate(this.$gettext('There were errors while integrating.<br><br>Please try again or write to <a href="mailto:%{integrationsEmail}">%{integrationsEmail}</a> with the following message: <br><br>'), {integrationsEmail: this.integrationsEmail}) + error.body.message
            }
            let obj = {
              title: 'ERROR',
              message: message,
              type: 'error'
            }
            this.$root.$children[0].$refs.simplert.openSimplert(obj)
            this.$router.push({ name: 'search' })
          })
      } else {
        let obj = {
          title: 'ERROR',
          message: this.$gettextInterpolate(this.$gettext('Your user doesn\'t have a company defined which is required to be able to enjoy the benefits of the e-commerce integrations.<br><br>Please write to <a href="mailto:%{helpEmail}">%{helpEmail}</a> to get this solved.'), {helpEmail: this.helpEmail}),
          type: 'error'
        }
        this.$root.$children[0].$refs.simplert.openSimplert(obj)
        this.$router.push({ name: 'search' })
      }
    }
  }
}
</script>
